import { LoadingOutlined } from '@ant-design/icons';
import { OverlayThumb } from 'src/components/OverlayThumb/Loadable';
import { PublicRoute } from 'src/components/RouteGuard';
import { Notfound } from 'src/containers/NotFound/Loadable';
import { DefaultLayout } from 'src/layouts/Loadable';
import React, {
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { Helmet } from 'react-helmet-async';
import { Route, Router, Switch } from 'react-router-dom';
import { GlobalStyle } from 'src/styles/global-styles';
import { history } from 'src/utils/history';
import CheckNewVersion from './components/CheckNewVersion';
import { AppWrapper } from './styled';
import 'src/lang/config';
import { useTranslation } from 'react-i18next';
import ModalRedirectMobile from 'src/components/Modal/ModalRedirectMobile';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const App: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleInvalidToken = (e: any) => {
      if (
        e.key == null ||
        (e.key === 'tokenData' && e.oldValue && !e.newValue)
      ) {
        // Your logout logic here
        // console.log(e);
        window.location.reload();
        // logoutAction(history);
      }
    };
    window.addEventListener('storage', handleInvalidToken);
    return function cleanup() {
      window.removeEventListener(
        'storage',
        handleInvalidToken,
      );
    };
  }, []);

  useLayoutEffect(() => {
    const handleStorageChange = (event: any) => {
      if (event.storageArea !== localStorage) return;
      if (!event.storageArea?.['tokenData']) return;
    };
    window.addEventListener('storage', handleStorageChange);
  }, []);

  const [isMobile, setIsMobile] = useState(false);
  const [appStoreLink, setAppStoreLink] = useState('');

  useLayoutEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    // Kiểm tra nếu User Agent chứa các từ khóa chỉ ra trình duyệt điện thoại
    if (
      userAgent.includes('android') ||
      userAgent.includes('iphone') ||
      userAgent.includes('ipad') ||
      userAgent.includes('windows phone') ||
      userAgent.includes('blackberry') ||
      userAgent.includes('mobile')
    ) {
      setIsMobile(true);
      if (
        userAgent.includes('iphone') ||
        userAgent.includes('ipad')
      ) {
        setAppStoreLink(
          'https://apps.apple.com/vn/app/mobifone-ework/id1639506595?l=vi',
        );
      } else {
        setAppStoreLink(
          'https://play.google.com/store/apps/details?id=vn.mobifone.mobiework',
        );
      }
    }
  }, []);

  const handleRedirectApp = () => {
    window.location.href =
      'vn.mobifone.mobiework://dashboard';
  };

  const handleRedirectAppStore = () => {
    window.location.href = appStoreLink;
  };

  const handleCancel = () => {
    setIsMobile(false);
  };

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet
          titleTemplate="%s - ework"
          defaultTitle={t('title')}
        >
          <meta name="description" content="" />
        </Helmet>

        <CheckNewVersion>
          {(
            loading: any,
            isLatestVersion: any,
            refreshCacheAndReload: any,
          ) => {
            if (loading)
              return (
                <OverlayThumb
                  icon={<LoadingOutlined />}
                  label="Loading..."
                />
              );
            if (!loading && !isLatestVersion)
              refreshCacheAndReload();
            return (
              <AppWrapper>
                <Router history={history}>
                  <Switch>
                    <Route
                      path="/"
                      // name="dashboard"
                      render={props => (
                        <DefaultLayout {...props} />
                      )}
                    />
                    <PublicRoute component={Notfound} />
                  </Switch>
                </Router>
                <ModalRedirectMobile
                  isOpen={isMobile}
                  title="THÔNG BÁO"
                  subTitle="Đã có phiên bản trên điện thoại di động. Vui lòng truy cập hoặc tải ứng dụng để tiếp tục sử dụng dịch vụ."
                  buttonRedirectApp="Mở app"
                  buttonOpenAppStore="Tải app"
                  onRedirectApp={handleRedirectApp}
                  onOpenAppStore={handleRedirectAppStore}
                  onCancel={handleCancel}
                />
              </AppWrapper>
            );
          }}
        </CheckNewVersion>
        <GlobalStyle />
      </QueryClientProvider>
    </>
  );
};

export default App;
